import { useEffect } from 'react';

const setAppHeight = () => {
  if (typeof window !== 'undefined') {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
  }
};

export function useViewportHeight() {
  useEffect(() => {
    // 初始化app高度
    setAppHeight();

    // 监听页面大小变化动态改变高度
    window.addEventListener('resize', setAppHeight);
    window.addEventListener('orientationchange', setAppHeight);

    return () => {
      window.removeEventListener('resize', setAppHeight);
      window.removeEventListener('orientationchange', setAppHeight);
    };
  }, []);
}

